import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  template: `
    <section class="not-found">
      <h1>404 - {{ 'Page_Not_Found_tr' | translate }}</h1>
      <p>{{ 'The_page_you_are_looking_for_doesnt_exist_tr' | translate }}</p>
      <a routerLink="/">{{ 'Return_to_dashboard_tr' | translate }}</a>
    </section>
  `,
  styles: [
    `
      .not-found {
        margin: 4rem auto;
        max-width: 480px;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
      h1 {
        font-size: clamp(1.8rem, 3vw, 2.6rem);
      }
      a {
        color: var(--color-primary, #1a73e8);
        text-decoration: underline;
      }
    `,
  ],
})
export class NotFoundComponent {}
